import { lazy, Suspense, type ComponentProps } from "react";

import { Skeleton } from "@/components/ui/skeleton";

// The contact page ships in the entry chunk; the Customer profile (charts, word
// cloud, insights, purchases) loads on demand so it never counts against the
// entry bundle budget (scripts/bundle-budget.json).
const ContactProfileCard = lazy(() =>
  import("./ContactProfileCard").then((module) => ({
    default: module.ContactProfileCard,
  })),
);

export const LazyContactProfileCard = (
  props: ComponentProps<typeof ContactProfileCard>,
) => (
  <Suspense fallback={<Skeleton className="h-10 w-full" aria-busy="true" />}>
    <ContactProfileCard {...props} />
  </Suspense>
);
